module.exports = __webpack_public_path__ + "img/alert_swap.90aa3457.svg";